module.exports = __webpack_public_path__ + "static/media/39.94e4c554.jpg";